import axios from 'axios';

/**
 * Flattens an API error response into one display string. Three shapes
 * coexist across the backend: {detail: "..."} (auth_views.py's older
 * endpoints), {error: "..."} (admin_views.py), and DRF's default
 * {field: ["msg", ...]} from serializer validation (the new auth endpoints
 * in auth_serializers.py). Falls back to `fallback` if none match.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  if (!axios.isAxiosError(error)) {
    return fallback;
  }

  const data = error.response?.data;
  if (!data || typeof data !== 'object') {
    return fallback;
  }

  if (typeof data.detail === 'string') {
    return data.detail;
  }
  if (typeof data.error === 'string') {
    return data.error;
  }

  const fieldMessages = Object.values(data)
    .flat()
    .filter((value): value is string => typeof value === 'string');
  if (fieldMessages.length > 0) {
    return fieldMessages.join(' ');
  }

  return fallback;
}
